module.exports = __webpack_public_path__ + "img/selfAdhesive10.572c655d.jpg";